import React, { useState, useEffect } from 'react';
import './peopleImgtitle.css';
import ImageRenderer from './ImageRenderer';
import { storeUserSendInteractionWithOthers } from '../../StateManagement/slicers/userSlicer';
import { useDispatch } from 'react-redux';

export default function PeopleImgTitle(props) {
  const [peopleTitleImg, setPeopleTitleImg] = useState([]);
  const dispatch = useDispatch();
  const [follow, setFollow] = useState([]);

  useEffect(() => {
    if (props.valueToRender?.length > 0) {
      setPeopleTitleImg(props.valueToRender);
    }
  }, [props.valueToRender]);

  function handleFollow(e) {
    if (e.value === false || e.value === 0 || !follow.includes(e.index)) {
      dispatch(
        storeUserSendInteractionWithOthers({
          data: {
            if_requested: true,
            if_request_accepted: true,
          },
          id: e.id,
        }),
      );
      setFollow(state => [...state, e.index]);
    }
    if (e.value === true || e.value === 1 || follow.includes(e.index)) {
      let emptyArray = [];
      const indexFound = follow.indexOf(e.index);
      const currentValues = follow;
      currentValues.splice(indexFound, 1);
      currentValues.forEach(item => {
        emptyArray.push(item);
      });
      dispatch(
        storeUserSendInteractionWithOthers({
          data: {
            if_requested: false,
            if_request_accepted: false,
            if_follows: false,
          },
          id: e.id,
        }),
      );
      setFollow(emptyArray);
    }
  }

  const renderImgTitle = peopleTitleImg.map(perPeopleDetail => {
    return (
      <div className="profile_people_title_sub_title_container" key={Math.random()}>
        <div className="people_img_title_container">
          {perPeopleDetail.peopleFirstName && perPeopleDetail.peopleLastName ? (
            <ImageRenderer firstName={perPeopleDetail.peopleFirstName} lastName={perPeopleDetail.peopleLastName} />
          ) : (
            <img src={perPeopleDetail.peopleBackupImg} alt="people" className="people_img_self" loading="lazy" />
          )}

          <div className="peoplw_title_text_subtitle_contianer">
            <h6 className="people_title_text">{perPeopleDetail.peopleTitle}</h6>
            <p className="people_sub_title_text">{perPeopleDetail.peopleSubTitle}</p>
          </div>
        </div>

        <button
          className="follow_btn"
          onClick={() =>
            handleFollow({
              index: perPeopleDetail?.index,
              value: perPeopleDetail?.value,
              id: perPeopleDetail?.id,
            })
          }
        >
          Follow
        </button>
      </div>
    );
  });

  return <>{peopleTitleImg.length > 0 ? renderImgTitle : null}</>;
}
